import axiosInstance from './axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const saveM11Changes = async (apiToken = null, stepCount = null, m11ResearchStudyFoi = null, changesStates = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!stepCount) {
        console.log("no stepCount");
        return null;
    }
    if (!m11ResearchStudyFoi) {
        console.log("no m11ResearchStudyFoi");
        return null;
    }
    if (!changesStates) {
        console.log("no changesStates");
        return null;
    }
    if (Object.keys(changesStates).length === 0) {
        console.log("no content in changesStates");
        return null;
    }
    let body = {
        'functionid': 'savem11changes',
        'apiToken': apiToken,
        'stepCount': stepCount,
        'm11ResearchStudyFoi': m11ResearchStudyFoi
    };
    for (const key in changesStates) {
        body[key] = changesStates[key];
    }
    console.log("CALLING SERVER with savem11changes");
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: body,
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from savem11changes call");
    }).catch((error) => { console.log(error); });
};

export default saveM11Changes;